module.exports = __webpack_public_path__ + "img/20190614161857551.85870cf2.png";